import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../../_services/common.service';
import { DialogService } from '../../_services';
import { StringConstants } from '../../_constants/stringConstants';
import { File } from '@ionic-native/file/ngx';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-document-display',
  templateUrl: './app-document-display.component.html',
})
export class AppDocumentDisplayComponent implements OnInit {

  // private pleaseWait: string = this.translate.instant('MESSAGES.PLEASE_WAIT');

  @Input() options: any = '';
  loading = true;
  pdfsrc: any = '';

  constructor(
    private dialogService: DialogService,
    private file: File,
    private commonService: CommonService,
  
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.init();
  }

  async init() {
    if (this.options.isLocal) {
      await this.readLocalPDF(this.options.url);
      this.loading = false;
    } else {
      this.pdfsrc = this.options.url;
      this.loading = false;
    }
  }

  setAppBusy() {
    this.loading = true;
    this.dialogService.showWaitMessage(this.translate.instant('MESSAGES.PLEASE_WAIT'));
  }

  setAppIdle() {
    this.loading = false;
    this.dialogService.hideWaitMessage();
  }

  async readLocalPDF(localPath) {
    const localPaths = localPath.split('/');
    const fileName = localPaths.pop();
    const filePath = localPaths.join('/');
    const base64String = await this.file.readAsDataURL(filePath, fileName);
    const pdfUrl = base64String.slice(28);
    this.pdfsrc = this.commonService.base64toArrayBuffer(pdfUrl)
  }

}
